<ng-container *ngIf="!print">
  <div *ngFor="let message of transcript" class="message-wrap"
       [ngStyle]="{'justify-content': message.role === 'bot' ? 'start' : 'end'}"
       (click)="onMessageClick(message.secondsFromStart)">
    <div class="card" [dir]="message.role === 'bot'? 'ltr': 'rtl'">
      <ng-container *ngIf="message.role === 'bot'; else userHeader">
        <div class="chat-message-header">
          <ng-container *ngIf="agentFirstName === 'Misha'">
            <img [src]="'/assets/img/conference/misha.jpg'">
          </ng-container>
          <ng-container *ngIf="agentFirstName === 'Amanda'">
            <img [src]="'/assets/img/conference/amanda.jpg'">
          </ng-container>
          <div class="subtitle">{{ agentFirstName }}</div>
        </div>
      </ng-container>
      <ng-template #userHeader>
        <div class="chat-message-header">
          <div class="user-ava">{{ userFirstName.substring(0, 1) }}{{ userLastName.substring(0, 1) }}</div>
          <div class="subtitle">{{ userFirstName }} {{ userLastName }}</div>
        </div>
      </ng-template>
      <div class="content" dir="ltr">
        <div style="color: #8E8E93; font-size: smaller;">{{ message.secondsFromStart | secToString }}</div>
        {{ message.message }}
      </div>
    </div>
  </div>
</ng-container>

<ng-container *ngIf="print">
  <div class="print-version">
    <div *ngFor="let message of transcript" class="print-message-wrap">
      <div class="print-message-header" style="padding-top: 15px;">
        <div style="font-weight: 500;">
          {{ message.role === 'bot' ? agentFirstName : userFirstName + ' ' + userLastName }}
        </div>
        <div style="color: #8E8E93; font-size: smaller;">({{ message.secondsFromStart | secToString }})</div>
      </div>
      <div>{{ message.message }}</div>
    </div>
  </div>
</ng-container>
